import * as React from 'react';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IErrorAction {
  label: string;
  onClick: () => void;
  theme?: 'fill_primary' | 'fill_white_primary';
}

interface IErrorLayoutProps {
  image?: string;
  title: React.ReactNode;
  description: React.ReactNode;
  actions: IErrorAction[];
}

export const ErrorLayout: React.FC<IErrorLayoutProps> = ({ image, title, description, actions }) => {
  return (
    <div className={styles['vertical-container']}>
      <div className={styles['container']}>
        {image && <div className={styles['image']} style={{ backgroundImage: `url("${image}")` }} />}
        <div className={styles['description']}>
          <UIHeading2 textAlign="center">{title}</UIHeading2>
          <UIText1 textAlign="center">{description}</UIText1>
        </div>
        <div className={styles['action']}>
          {actions.map((action, index) => (
            <Button key={index} size="M" theme={action.theme || 'fill_primary'} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
